import { render } from "./KeyboardReturn.vue?vue&type=template&id=fe8d0a1a"
import script from "./KeyboardReturn.vue?vue&type=script&lang=js"
export * from "./KeyboardReturn.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/KeyboardReturn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fe8d0a1a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fe8d0a1a', __exports__)) {
    api.reload('fe8d0a1a', __exports__)
  }
  
  module.hot.accept("./KeyboardReturn.vue?vue&type=template&id=fe8d0a1a", () => {
    api.rerender('fe8d0a1a', render)
  })

}


export default __exports__